import { Quota } from './quota.model';

export class QuotaSummary extends Quota {
  completes: number;
}
